import Vue from 'vue'

import DateTime from '@/components/formElements/DateTime'
Vue.component('DateTime', DateTime)

// Import Vue Multiselect Globally Component
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
